import elementTypes from '../../elements/types';

export function countElement(editor, type) {

  let count = 0;

  const children = editor.children;

  for (let node of children) {

    if (node.type === type) {
      count++;
    }

  }

  return count;

}

export function findNodeByType(nodes, type) {

  for (let node of nodes) {

    if (node.type === type) {
      return node;
    }

  }

  return null;

}

export function hasSingleProducerMeeting(editor) {

  return countElement(editor, elementTypes.SINGLE_PRODUCER_MEETING) === 1;

};

export function hasHTStartupEvent(editor) {

  return countElement(editor, elementTypes.HT_STARTUP_EVENT) === 1;

}

export function hasHTStartupEventTemplate(editor) {

  return countElement(editor, elementTypes.HT_STARTUP_EVENT_TEMPLATE) === 1;

}